// searchsync-clear-refinements-component.js

import { getInstance, registerWidget } from './searchsync-create-instance';
import { connectClearRefinements } from 'instantsearch.js/es/connectors';

const getSelectedStatuses = () =>
  Array.from(document.querySelectorAll('.tgbl-refinement-item__checkbox:checked')).map(cb => cb.value);

const clearPseudoRefinements = (indexName) => {
  document.querySelectorAll('.tgbl-refinement-item__checkbox').forEach(cb => (cb.checked = false));
  const search = getInstance(indexName);
  const configureState = search.renderState[indexName]?.configure;
  if (configureState) {
    configureState.refine({ filters: undefined });
  }
};

const createPseudoAwareClearRefinements = ({ container, indexName, label = 'Clear refinements' }) => {
  let lastCanRefine = false;
  let onCheckboxChange;

  const hasPseudo = () => getSelectedStatuses().length > 0;

  const syncButtonState = () => {
    const btn = container.querySelector('.ais-ClearRefinements-button');
    if (!btn) return;
    const disabled = !(lastCanRefine || hasPseudo());
    btn.disabled = disabled;
    btn.classList.toggle('ais-ClearRefinements-button--disabled', disabled);
  };

  const render = ({ canRefine, refine }, isFirstRender) => {
    lastCanRefine = canRefine;

    if (isFirstRender) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ais-ClearRefinements-button tgbl-clear-refinements-button tgblAlgolia-button';
      btn.textContent = label;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        refine(); // clear Algolia refinements
        clearPseudoRefinements(indexName); // clear pseudo refinements
        syncButtonState(); // immediate UI sync
      });
      container.appendChild(btn);

      onCheckboxChange = (e) => {
        if (e.target && e.target.classList && e.target.classList.contains('tgbl-refinement-item__checkbox')) {
          syncButtonState();
        }
      };
      document.addEventListener('change', onCheckboxChange, true);
    }

    syncButtonState();
  };

  const unmount = () => {
    if (onCheckboxChange) {
      document.removeEventListener('change', onCheckboxChange, true);
      onCheckboxChange = null;
    }
    container.innerHTML = '';
  };

  return connectClearRefinements(render, unmount)({});
};

function initClearRefinementsWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblSearchsyncDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);

  const elements = document.querySelectorAll("[data-filter-type='clearRefinements']");
  const elementsArray = Array.from(elements);

  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute('data-index');
    if (!acc[dataIndexValue]) acc[dataIndexValue] = [];
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  for (const dataIndexValue in elementsGroupedByIndex) {
    if (!elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) continue;

    const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
    const search = getInstance(dataIndexValue);

    elementsWithSameIndex.forEach((element) => {
      
      const widgetID = element.getAttribute('data-id')
      const widgetData = tgblAlgoliaData[widgetID]
      const label = widgetData.label
      
      const widget = createPseudoAwareClearRefinements({
        container: element,
        indexName: dataIndexValue,
        label: label || 'Clear refinements',
      });

      search.addWidgets([widget]);
      registerWidget(element);
    });
  }
}

export { initClearRefinementsWidget };
